/**************************************************
 * Nombre:       Home_Colecciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {TituloTexto} from "./SubComponentes/TituloTexto";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import Tarjeta_Coleccion from "../../Tarjetas/Tarjeta_Coleccion";

const Home_Colecciones = ({dir = 'flex-start'}) => {
    const cData = useContext(contexApp)
    const [colecciones, setColecciones] = useState([]);

    useEffect(() => {

        if (cData.colecciones) {
            setColecciones(cData.colecciones);
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <TituloTexto texto={'NUESTRAS'} titulo={'COLECIONES'} dir={dir}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{mt: 8}}
            >

                {colecciones.map((it, index) => (
                    <Grid key={index + 'w9'} container size={{xs: 12, sm: 6, md: 6}}
                          sx={{justifyContent: 'flex-start'}}>
                        <Tarjeta_Coleccion item={it}/>
                    </Grid>
                ))}

            </Grid>

        </Grid>
    )

}
export default Home_Colecciones

const items = [1, 2, 3]